import {observer} from "mobx-react";

import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    ContainerText, Container,
    ContentText, FieldName, FieldValue, Text,
} from "@dropDesk/presentation/pages/subscription/ui/modals/pay_info/input_payment_info/styled";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import DropDeskIcon from "@dropDesk/storage/icons";
import {
    formatDateToDDMMYYYY,
    formatDateToDDMMYYYYHHMM,
} from "@dropDesk/utils/helpers/date_helper";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {formatCurrency} from "@dropDesk/utils/helpers/common";
import {PaymentItemType} from "@dropDesk/domain/entities/payment/payment.enum";
import {
    TableWrapper, InvoiceTable, TableHead, TableHeaderRow, TableHeaderCell,
    TableBody, Divider, FooterRow, FooterLabel, FooterValue,
} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/invoices_history/table/invoice_expanded/styled";
import InvoiceItem
    from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/invoices_history/table/invoice_expanded/invoice_item";

const InputPaymentInfo = observer(
    ({
         payment,
         labelNewPeriod,
     }: {
        payment: PaymentEntity
        labelNewPeriod: string
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <Container>
                {payment.createdAt &&
                    <ContentText>
                        <DropDeskIcon
                            icon={payment.isBoleto ? ICONS_DROPDESK.billet : ICONS_DROPDESK.pix}
                            size={11}
                            color={colors.hintInverse}
                        />
                        <Text size={14} color={colors.hintInverse} style={{fontWeight: 'bold'}}>
                            &nbsp;Gerado em {formatDateToDDMMYYYYHHMM(new Date(payment.createdAt))}
                        </Text>
                    </ContentText>
                }

                <ContainerText>
                    <FieldName>
                        <ContentText>
                            <Text size={14} color={colors.text}>
                                Valor total:
                            </Text>
                        </ContentText>
                    </FieldName>
                    <FieldValue>
                        <ContentText>
                            <Text size={14} color={colors.text}>
                                {formatCurrency(payment.value)}
                            </Text>
                        </ContentText>
                    </FieldValue>
                </ContainerText>

                <ContainerText>
                    <FieldName>
                        <ContentText>
                            <Text size={14} color={colors.text}>
                                Período:
                            </Text>
                        </ContentText>
                    </FieldName>
                    <FieldValue>
                        <ContentText>
                            <Text size={14} color={colors.text}>
                                {labelNewPeriod}
                            </Text>
                        </ContentText>
                    </FieldValue>
                </ContainerText>
                {payment.expireDate &&
                    <ContainerText>
                        <FieldName>
                            <ContentText>
                                <Text size={14} color={colors.text}>
                                    Vencimento:
                                </Text>
                            </ContentText>
                        </FieldName>
                        <FieldValue>
                            <ContentText>
                                <DropDeskIcon
                                    icon={ICONS_DROPDESK.clock}
                                    size={11}
                                    color={colors.text}
                                />
                                <Text size={14} color={colors.text}>
                                    &nbsp;{formatDateToDDMMYYYY(new Date(payment.expireDate))}
                                </Text>
                            </ContentText>
                        </FieldValue>
                    </ContainerText>}
                {payment.items && payment.items.length > 0 && (
                    <>
                        <TableWrapper borderColor={colors.border} style={{marginTop: 8}}>
                            <InvoiceTable>
                                <TableHead>
                                    <TableHeaderRow background={colors.delicateBackground} borderColor={colors.border}>
                                        <TableHeaderCell color={colors.hintInverse}>Produto</TableHeaderCell>
                                        <TableHeaderCell color={colors.hintInverse}>Descrição</TableHeaderCell>
                                        <TableHeaderCell color={colors.hintInverse}>Período</TableHeaderCell>
                                        <TableHeaderCell color={colors.hintInverse}>Valor</TableHeaderCell>
                                    </TableHeaderRow>
                                </TableHead>
                                <TableBody>
                                    {payment.items.map((item, index) => (
                                        <InvoiceItem
                                            key={index}
                                            item={item}
                                            periodFormatted={payment.periodFormatted}
                                            colors={colors}
                                        />
                                    ))}
                                </TableBody>
                            </InvoiceTable>
                        </TableWrapper>
                        <Divider borderColor={colors.border}/>
                        <FooterRow>
                            <FooterLabel color={colors.hint}>Total da cobrança</FooterLabel>
                            <FooterValue color={colors.text}>{formatCurrency(payment.value)}</FooterValue>
                        </FooterRow>
                    </>
                )}



            </Container>
        )
    })
export default InputPaymentInfo;
